module.exports = __webpack_public_path__ + "img/logro1.9589adce.webp";